
<template>
  <div id="data-list-list-view" class="data-list-container">
    <vx-card>
      <div class="vx-row">
        <div class="vx-col w-full sm:w-1/2 lg:w-1/2 mb-base">
          <vs-breadcrumb>
            <li><router-link to="/">Dashboard</router-link><span class="vs-breadcrum--separator">/</span></li>
            <li aria-current="page" class="active">Interventions</li>
          </vs-breadcrumb>
        </div>
        <div class="vx-col w-full sm:w-1/2 lg:w-1/2 mb-2 text-right">
          <vs-button type="line" line-origin="left" color="danger" class="mr-5"  @click="filterFildes()">
            <feather-icon icon="FilterIcon" svgClasses="h-4 w-4"  />  Filtrer
            <!-- <feather-icon icon="XCircleIcon" svgClasses="h-4 w-4"/> -->
          </vs-button>
          <vs-button type="line" line-origin="left" color="success" @click="addNewData">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" /> Ajouter intervention
          </vs-button>
        </div>
      </div>

      <vs-table ref="table"  v-model="selected" pagination :max-items="itemsPerPage" :data="filteredItems" noDataText="Aucun intervention trouvé">

        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between pl-0 ">

          <div class="vx-row w-full mb-2">
            <div class="vx-col md:w-1/6 w-full">
              <vs-input label="N° Intervention" v-model="f_search" class=" mr-1 w-full" name="search" />
            </div>
            <div class="vx-col md:w-1/6 w-full">
              <vs-input label="Lieu" v-model="f_lieu" class=" mr-1 w-full" name="lieu" />
            </div>
            <div class="vx-col md:w-1/4 w-full">
              <div class="vs-component vs-con-input-label vs-input  w-full vs-input-primary">
                <label for="" class="vs-input--label">Artisans</label>
                <v-select multiple class="w-full" name="artisan_ids" :clearable="true" label="full_name" v-model="f_artisans_id" :options="Artisan_choices" :reduce="artisan => artisan.id" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                    <div slot="no-options">Désolé, aucun artisan correspondante.</div>
                </v-select>
              </div>
            </div>
            <div class="vx-col md:w-1/4 w-full">
              <div class="vs-component vs-con-input-label vs-input  w-full vs-input-primary">
                <label for="" class="vs-input--label">Clients</label>
                <v-select multiple class="w-full" name="client_ids" :clearable="true" label="full_name" v-model="f_clients_id" :options="Client_choices" :reduce="client => client.id" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                    <div slot="no-options">Désolé, aucun client correspondante.</div>
                </v-select>
              </div>
            </div>
            <div class="vx-col md:w-1/6 w-full">
              <div class="vs-component vs-con-input-label vs-input  w-full vs-input-primary">
                <label for="" class="vs-input--label" >Etat</label>
                <v-select name="etat" class="ml-1" :clearable="false" label="label" v-model="f_etat" :options="Status_choices" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <div slot="no-options">Désolé, aucune etat correspondante.</div>
                </v-select>
              </div>
            </div>
            <div class="vx-col md:w-1/6 w-full">
              <vs-input label="N° Téléphone" v-model="f_tel" class=" mr-1 w-full" name="tel" />
            </div>
            <div class="vx-col md:w-1/6 w-full">
              <vs-input label="Code postal" v-model="f_zip" class=" mr-1 w-full" name="zip" />
            </div>
            <div class="vx-col md:w-1/4 w-full">
              <div class="vs-component vs-con-input-label vs-input  w-full vs-input-primary">
                <label for="" class="vs-input--label" >Date de création</label><br>
                <date-range-picker
                  ref="picker"
                  class="w-full"
                  :locale-data="{ direction: 'ltr',
                                  format: 'mm/dd/yyyy',
                                  separator: ' - ',
                                  applyLabel: 'Valider',
                                  cancelLabel: 'Annuler',
                                  weekLabel: 'W',
                                  customRangeLabel: 'Custom Range',
                                  daysOfWeek: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
                                  monthNames: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                                  firstDay: 0
                                }"
                  v-model="dateRange"
                  :ranges="{
                    'Today': [today, new Date(today.getFullYear(), today.getMonth(), today.getDate(), 11, 59, 59, 999)],
                    'Yesterday': [new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1), new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1, 11, 59, 59, 999)],
                    'This month': [new Date(today.getFullYear(), today.getMonth(), 1), new Date(today.getFullYear(), today.getMonth() + 1, 0, 11, 59, 59, 999)],
                    'Last month': [new Date(today.getFullYear(), today.getMonth() - 1, 1),new Date(today.getFullYear(), today.getMonth(), 0, 11, 59, 59, 999)],
                    'This year': [new Date(today.getFullYear(), 0, 1),new Date(today.getFullYear(), 11, 31, 11, 59, 59, 999)],
                    'Last year': [new Date(today.getFullYear() - 1, 0, 1),new Date(today.getFullYear() - 1, 11, 31, 11, 59, 59, 999)]
                  }"
                >
                    <template v-slot:input="picker" style="min-width: 350px;">
                      <feather-icon icon="CalendarIcon" svgClasses="h-4 w-4" />
                          {{ picker.startDate | moment("DD-MMMM-YYYY") }} - {{ picker.endDate | moment("DD-MMMM-YYYY") }}
                      <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />

                    </template>

                    <!--    ranges (new slot syntax) -->
                    <template #ranges="ranges">
                      <div class="ranges">
                        <ul>
                          <li v-for="(range, name) in ranges.ranges" :key="name" @click="ranges.clickRange(range)">
                            <b v-if="name == 'Today'">Aujourd'hui</b>
                            <b v-if="name == 'Yesterday'"> Hier</b>
                            <b v-if="name == 'This month'"> Ce mois</b>
                            <b v-if="name == 'This year'"> Cette année</b>
                            <b v-if="name == 'Last month'">Mois dérnier</b>
                            <b v-if="name == 'Last year'">Année dérnière</b>
                 
                          </li>
                        </ul>
                      </div>
                    </template>
                </date-range-picker>
              </div>
            </div>

            <div class="vx-col md:w-1/4 w-full" v-if="permission">
              <div class="vs-component vs-con-input-label vs-input  w-full vs-input-primary">
                <label for="" class="vs-input--label">Utilisateurs</label>
                <v-select multiple class="w-full" name="user_ids" :clearable="true" label="name" v-model="f_users_id" :options="User_choices" :reduce="user => user.id" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                    <div slot="no-options">Désolé, aucun utilisateur correspondante.</div>
                </v-select>
              </div>
            </div>
          </div>
        </div>

        <template slot="thead">

          <vs-th sort-key="num_intervention">N° Intervention</vs-th>
          <vs-th sort-key="lieu">Lieu Intervention</vs-th>
          <vs-th sort-key="date_intervention">Date de création</vs-th>
          <vs-th sort-key="artisans">Artisans</vs-th>
          <vs-th sort-key="client">Client</vs-th>
          <vs-th sort-key="status">Etat</vs-th>
          <vs-th></vs-th>
          <vs-th>Actions</vs-th>
        </template>

          <template slot-scope="{data}">
            <tbody>
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" :class="{'font-bold': tr.from_web_site && tr.new}">

                <vs-td>
                  <p @click.stop="editData(tr)" class="num_object">BI{{ tr.id | strPadStart('0') }}</p>
                </vs-td>

                <vs-td>
                  <p>{{ tr.lieu }}</p>
                </vs-td>

                <vs-td>
                  <p>{{ tr.created_at | date }}</p>

                </vs-td>

                <vs-td>
                  <p>{{ tr.artisans.map(artisan => artisan.firstname + ' ' +artisan.lastname).join(",") }}</p>
                </vs-td>

                <vs-td>
                  <p>{{ tr.name_client }}</p>
                </vs-td>

                <vs-td>
                  <p>
                    <vs-chip v-if="tr.status == 0" color="warning">En attente</vs-chip>
                    <vs-chip v-if="tr.status == 1" color="dark">Valider</vs-chip>
                    <vs-chip v-if="tr.status == 2" color="primary">En cours</vs-chip>
                    <vs-chip v-if="tr.status == 3" color="success">Terminer</vs-chip>
                    <vs-chip v-if="tr.status == 4" color="danger">Refuser</vs-chip>
                    <vs-chip v-if="tr.status == 5" color="danger">Annuler - trop chère</vs-chip>
                    <vs-chip v-if="tr.status == 6" color="danger">Annuler - artisan non disponible</vs-chip>
                    <vs-chip v-if="tr.status == 7" color="danger">Annuler - client annule</vs-chip>
                    <vs-chip v-if="tr.status == 8" color="danger">Annuler - hors secteur</vs-chip>
                    <vs-chip v-if="tr.status == 9" color="danger">Annuler - concurrence</vs-chip>
                  </p>
                </vs-td>


                <vs-td>
                  <p>
                    <vs-chip v-if="tr.from_web_site" color="success">Web</vs-chip>
                    <vs-chip v-else color="warning">Télephone</vs-chip>
                  </p>
                </vs-td>

                <vs-td class="whitespace-no-wrap">
                  <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" class="ml-2" @click.stop="editData(tr)"/>
                  <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" class="ml-2" @click.stop="deleteData(tr.id)"  v-if="permission"/>



                  <vs-dropdown vs-trigger-click v-if="tr.quote || tr.invoice">
                    <feather-icon icon="PrinterIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" class="ml-2" />

                    <vs-dropdown-menu >
                      <vs-dropdown-item v-if="tr.quote" @click="downloadPdf(tr.quote.api_id)">Imprimer Devis </vs-dropdown-item>
                      <vs-dropdown-item v-if="tr.invoice" @click="downloadPdf(tr.invoice.api_id)">Imprimer Facture </vs-dropdown-item>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </vs-td>

              </vs-tr>
            </tbody>
          </template>
      </vs-table>
    </vx-card>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { mapGetters, mapActions } from "vuex"
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import { moment } from 'vue-moment';


import Vue from 'vue'

export default {
  components: {
    vSelect,DateRangePicker,moment
  },
  data() {
    var date = new Date();
    let startDate = new Date(date.getFullYear(), date.getMonth(), 1);
    let endDate = new Date();

    let today = new Date()
    today.setHours(0, 0, 0, 0)

    return {
      filter : false,
      f_artisans_id: [],
      f_clients_id: [],
      f_users_id: [],
      f_etat: null,
      f_search: null,
      f_lieu: null,
      f_tel: null,
      f_zip: null,
      selected: [],
      // products: [],
      itemsPerPage: 50,
      isMounted: false,
      Status_choices : [
        {label: 'Tous', value: null},
        {label: 'En attente', value: 0},
        {label: 'Valider', value: 1},
        {label: 'En cours', value: 2},
        {label: 'Terminer', value: 3},
        {label: 'Refuser', value: 4},
        {label: 'Annuler - trop chère', value: 5},
        {label: 'Annuler - artisan non disponible', value: 6},
        {label: 'Annuler - client annule', value: 7},
        {label: 'Annuler - hors secteur', value: 8},
        {label: 'Annuler - concurrence', value: 9},
      ],

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},

      // Loading
      showLoading: false,

      dateRange: {startDate, endDate},

      today: today

    }
  },
  computed: {
    ...mapGetters('interventions', { 'data' : 'GET_ITEMS' }),
    ...mapGetters('artisans', {'Artisan_choices' : 'GET_ITEMS_FULL_NAME'}),
    ...mapGetters('clients', {'Client_choices' : 'GET_ITEMS_FULL_NAME'}),
    ...mapGetters('users', {'User_choices' : 'GET_ITEMS'}),
    currentPage() {
      if(this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems() {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.data.length
    },

    permission() {
      const role = Vue.$cookies.get('role');
      return role == 'Admin' ? true : false 
    },

    
    filteredItems() {

      let dataFilter = this.data

      if(this.f_artisans_id != null && this.f_artisans_id.length > 0) {
        dataFilter = dataFilter.filter(item => {
          return item.artisans.findIndex(artisan => (this.f_artisans_id.includes(artisan.id))) > -1
        })
      }

      if(this.f_clients_id != null && this.f_clients_id.length > 0) {
        dataFilter = dataFilter.filter(item => {
          return this.f_clients_id.includes(item.client_id)
        })
      }

      if(this.f_users_id != null && this.f_users_id.length > 0) {
        dataFilter = dataFilter.filter(item => {
          return item.historiques.findIndex(historique => (this.f_users_id.includes(historique.user_id))) > -1
        })
      }

      // if(this.f_users_id != null && this.f_users_id.length > 0) {
      //   dataFilter = dataFilter.filter(item => {
      //     return this.f_users_id.includes(item.user_id)
      //   })
      // }

      if(this.f_etat != null) {
        if(this.f_etat.value != null){
          dataFilter = dataFilter.filter(item => {
            return this.f_etat.value == item.status
          })
        }

      }

      if(this.f_search != null && this.f_search != "") {
        dataFilter = dataFilter.filter(item => {
          return this.numIntervention(item.id,"0").toLowerCase().includes(this.f_search.toLowerCase()) || item.lieu.trim().toLowerCase().includes(this.f_search.toLowerCase())
        })
      }

      if(this.f_lieu != null && this.f_lieu != "") {
        dataFilter = dataFilter.filter(item => {
          return item.lieu.toLowerCase().includes(this.f_lieu.toLowerCase())
        })
      }

       if(this.f_tel != null && this.f_tel != "") {
        dataFilter = dataFilter.filter(item => {
          console.log(item.client.tel)
          return item.client.tel && item.client.tel.replace(/ /g, "").includes(this.f_tel.replace(/ /g, ""))
        })
      }

      if(this.f_zip != null && this.f_zip != "") {
        dataFilter = dataFilter.filter(item => {
          return item.client.zipcode && item.client.zipcode.toString().includes(this.f_zip)
        })
      }

      dataFilter = dataFilter.filter(item => {
        return this.format_date(item.created_at) >= this.format_date(this.dateRange.startDate) && this.format_date(item.created_at) <= this.format_date(this.dateRange.endDate)
      })

      var search_object = {
        'num' : this.f_search,
        'artisans_id' : this.f_artisans_id,
        'clients_id' : this.f_clients_id,
        'etat' : this.f_etat,
        'lieu' : this.f_lieu,
        'tel' : this.f_tel,
        'zip' : this.f_zip,
        'users_id' : this.f_users_id
      }

      localStorage.setItem("interventions_search", JSON.stringify(search_object))

      return dataFilter
    }
  },
  watch: {
     showLoading (val) {
      if(val == true){
        this.$vs.loading({type: 'radius', color: '#be092f'})
      }else{
        this.$vs.loading.close()
      }
    }
  },
  methods: {
    ...mapActions('interventions', ['fetchItems','removeItem','setOld']),
    ...mapActions('artisans', {'fetchArtisans':'fetchItemsFullName'}),
    ...mapActions('clients', {'fetchClients':'fetchItemsFullName'}),
    ...mapActions('users', {'fetchUsers':'fetchItems'}),
    toggleDataSidebar(val=false) {
      this.addNewDataSidebar = val
    },
    addNewData() {
      this.$router.push('/intervention');
    },
    editData(intervention) {
      if(intervention.from_web_site && intervention.new) {
        this.setOld(intervention.id)
      }

      this.$router.push(`/intervention/${intervention.id}`);
    },

    deleteData(data) {
      this.$swal({
        title: 'Êtes-vous sûr?',
        text: "Vous ne pourrez pas revenir en arrière",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.showLoading = true
          this.removeItem(data).then(()=>{
              this.successMsg('Suppression','L\'intervention est bien supprimé');
          }).catch(()=>{
             this.errorMsg('Suppression','error au moment suppression')
          })
          this.showLoading = false;
        }
      });
    },
    successMsg(title,msg){
      this.$vs.notify({
        title: title,
        text: msg,
        color:'success',
        iconPack: 'feather',
        icon:'icon-check',
        position:'top-right'
      })
    },
    errorMsg(title,msg){
      this.$vs.notify({
        title: title,
        text: msg,
        color:'danger',
        iconPack: 'feather',
        icon:'icon-check',
        position:'top-right'
      })
    },
    filterFildes() {
      this.filter = !this.filter
      if(!this.filter) {
        this.f_artisans_id = []
        this.f_clients_id = []
        this.f_users_id = []
        this.f_etat = null
        this.f_search = null
        this.f_lieu = null
        this.f_tel = null
        this.f_zip = null

        var date = new Date();
        let startDate = new Date(date.getFullYear(), date.getMonth(), 1);
        let endDate = new Date();
        this.dateRange = {startDate, endDate}

        localStorage.removeItem("interventions_search");
      }
    },
    numIntervention(value, pattern = ""){
      return "BI".concat('',value.toString().padStart(4,pattern))
    },
    downloadPdf(id) {
      let a = document.createElement("a");
      a.setAttribute("href", `https://hellodepann.vosfactures.fr/invoices/${id}.pdf?api_token=8hpAUs73rV4vbcDRoDo`);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    format_date(date) {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2)
          month = '0' + month;
      if (day.length < 2)
          day = '0' + day;

      return [year, month, day].join('-');
    },
  },
  created() {
    this.fetchItems()
    this.fetchArtisans()
    this.fetchClients()
    this.fetchUsers()


    var search_object = JSON.parse(localStorage.getItem("interventions_search") || "[]")
    if(search_object && (search_object.num || search_object.artisans_id.length || search_object.clients_id.length || search_object.etat || search_object.lieu || search_object.tel || search_object.zip)) {
      this.f_search = search_object.num
      this.f_artisans_id = search_object.artisans_id
      this.f_clients_id = search_object.clients_id
      this.f_etat = search_object.etat
      this.f_lieu = search_object.lieu
      this.f_tel = search_object.tel
      this.f_zip = search_object.zip
      this.f_users_id = search_object.users_id

      this.filter = true
    }
  },
  mounted() {
    this.isMounted = true;
  },
  filters:{
    strPadStart(value, pattern = ""){ // Use padStart to complete the string
      return value.toString().padStart(4,pattern)
    },
    date(value) {
      var [date, time] = value.split("T")
      var [y, m, d] = date.split("-")
      var [h, min] = time.split(":")
      return d +'/'+ m +'/'+ y +' '+ h +':'+ min
    }
  }
}
</script>

<style scoped>

  .num_object:hover{
    color: #be092f;
  }

  .vs-con-dropdown.parent-dropdown {
    cursor: pointer !important;
  }

  .con-vs-dropdown--menu{
    width: 160px !important;
  }

  .con-vs-pagination {
    max-width: 50px !important;
  }

  .calendars {
    flex-wrap: nowrap !important;
  }
</style>
